import React from "react";
import logoD from "../assets/img/MPink.png";
import logo from "../assets/img/MPink.png";

const AuthHeader = ({ title, darkMode }) => {
  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      <img
        alt="LOGO"
        src={darkMode === true ? logo : logoD}
        className="image_upload__arrow d-flex mx-auto"
        width="60px"
      />

      <h3
        className={
          darkMode
            ? "fs--30 fw--600 normal-heading-dark mt-5 mb-4"
            : "fs--30 fw--600 normal-heading mt-5 mb-4"
        }
      >
        {title}
      </h3>
    </div>
  );
};

export default AuthHeader;
